(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["QQ-SplitScreenSlider"] && !Shopify.designMode) return;
  try {
    "use strict";function _typeof(e){return(_typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}!function(){function t(){var e=document.querySelectorAll(".qq-splitscreen-slider .QQ-JS-init-msg");e&&e.forEach(function(e){e.remove()})}var d;function i(){(d=document.getElementsByClassName("qq-splitscreen-slider")).length&&function e(){{var t,i,s;null==("undefined"==typeof $?"undefined":_typeof($))||null==window.$?((t=document.createElement("script")).id="qq-jquery",document.head.appendChild(t),t.type="text/javascript",t.src="https://code.jquery.com/jquery-3.6.0.min.js",t.onload=function(){e()}):document.getElementById("qq-slick")&&document.getElementById("qq-slick-css")?i=setInterval(function(){$.fn.slick&&(clearInterval(i),n())},10):(document.getElementById("qq-slick")||((s=document.createElement("script")).id="qq-slick",document.head.appendChild(s),s.type="text/javascript",s.src="https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.min.js",s.onload=function(){e()}),document.getElementById("qq-slick-css")||((s=document.createElement("link")).id="qq-slick-css",document.head.appendChild(s),s.type="text/css",s.rel="stylesheet",s.href="https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.css"))}}()}function n(){for(var e=0;e<d.length;e++){var t,i,s,n=d[e].id,o="qq"+n.replace("template--","").replace("shopify-section-","").replace("__","");document.getElementById(o)&&(t=$("#"+o).find(".qq-slide-video .qq-video-cover"),i=$("#"+o).find(".qq-slide-secondary-media .qq-video-cover"),s=$("#"+o).find(".qq-splitscreen-slides-fixed-media .qq-video-cover"),o=$("#"+o).find(".qq-splitscreen-slides-fixed-media .qq-fixed-secondary-media .qq-video-cover"),t&&t.click(function(e){e.preventDefault(),l(this.id,this.getAttribute("data-vidID"))}),i&&i.click(function(e){e.preventDefault(),l(this.id,this.getAttribute("data-vidID"))}),s&&s.click(function(e){e.preventDefault(),l(this.id,this.getAttribute("data-vidID"))}),o&&o.click(function(e){e.preventDefault(),l(this.id,this.getAttribute("data-vidID"))})),function(s){var n=$("#"+s).find(".qq-splitscreen-slides");{var e,t,i,o,d,l,r,a,c,u,q,p;n.length&&(e=$("#"+s+"  .qq-slider-arrows .qq-slider-prev"),t=$("#"+s+"  .qq-slider-arrows .qq-slider-next"),i=/true/i.test(n.attr("data-slider-autoplay")),o=1e3*Number(n.attr("data-slider-speed")),u=n.attr("data-slider-animation"),a=n.attr("data-slider-mobile-navigation"),d=n.attr("data-slider-dots-position-mobile"),l=n.attr("data-slider-adaptive-height"),p=n.attr("data-slider-disable-fade"),u="fade"==u,l=null!=l&&"false"!=l,a="arrows"==a?!(r=!0):"dots"==a?!(r=!1):r=!1,null==p||"false"==p?c=300:u=!(c=0),void 0!==(p=$("html").attr("dir"))&&!1!==p&&(q="rtl"==p),p=/true/i.test(n.attr("data-slider-dots")),self["sliderItems"+s]&&self["sliderItems"+s].slick("unslick"),self["sliderItems"+s]=$("#"+s+" .qq-splitscreen-slides").not(".slick-initialized").on("beforeChange",function(e,t,i,s){h(d,s,n),f(n)}).on("init",function(e,t){h(d,0,n),f(n)}).on("setPosition",function(e,t){var i=$("#"+s+" .qq-splitscreen-slides .slick-active").attr("data-slick-index");h(d,i,n),f(n)}).slick({arrows:!1,infinite:!0,centerMode:!1,rtl:q,slidesToScroll:1,slidesToShow:1,dots:p,fade:u,speed:c,adaptiveHeight:l,autoplay:i,autoplaySpeed:o,pauseOnHover:!0,prevArrow:e,nextArrow:t,responsive:[{breakpoint:768,settings:{dots:a,arrows:r,adaptiveHeight:!0}}]}))}}(n)}}function l(e,t){document.getElementById(e).style.display="none";t=document.getElementById(t);void 0!==t&&null!=t&&t.play()}function f(e){(e=(e.hasClass("qq-fixed-media")?e.parent():e).find(".qq-responsive-video-container")).length&&e.each(function(e){var t;$(this).hasClass("qq-portrait")&&(t=1.33*$(this).outerWidth(!0),$(this).css("height",t))})}function h(e,t,i){var s=i.find(".slick-dots"),n=i.parent().find('.slick-slide[data-slick-index="'+t+'"] .qq-slider-arrows'),o=i.parent().parent().find(".qq-slider-arrows.qq-fixed-arrows"),d=i.find('.slick-slide[data-slick-index="'+t+'"] .qq-slide-text'),l=i.find('.slick-slide[data-slick-index="'+t+'"] .qq-slide-media').height(),t=Number(i.attr("data-slider-dots-bottom-margin"));$(window).width()<=768?s.length&&"center"==e&&(d.hasClass("qq-mobile-first")?(s.css("top",d.outerHeight(!0)-s.outerHeight()/2),s.css("bottom","inherit")):d.hasClass("qq-mobile-second")&&(s.css("top",l-s.outerHeight()/2),s.css("bottom","inherit"))):(s.length&&"center"==e&&(s.css("top","inherit"),s.css("bottom",t+"px")),n.length&&n.css("top","inherit")),((n=0==n.length?i.parent().find(".qq-slider-arrows"):n).length||o.length)&&(n.hasClass("qq-over-images")?d.hasClass("qq-mobile-first")?n.css("top",d.outerHeight(!0)+l/2-n.outerHeight()/2):n.css("top",l/2-n.outerHeight()/2):n.hasClass("qq-between")&&(d.hasClass("qq-mobile-first")?n.css("top",d.outerHeight(!0)-n.outerHeight(!0)/2):n.css("top","0")),o.length&&(i=i.parent().find(".qq-splitscreen-fixed-media"),o.hasClass("qq-over-images")?i.hasClass("qq-mobile-first")?o.css("top",i.outerHeight(!0)/2-o.outerHeight()/2):o.css("top",d.outerHeight(!0)+i.outerHeight(!0)/2-o.outerHeight()/2):o.hasClass("qq-between")&&(i.hasClass("qq-mobile-first")?o.css("top",i.outerHeight(!0)-o.outerHeight()/2):o.css("top",d.outerHeight(!0)-o.outerHeight()/2))))}window.addEventListener("shopify:section:load",function(e){t()}),t(),"loading"!==document.readyState?i():document.addEventListener("DOMContentLoaded",function(){i()}),window.addEventListener("shopify:section:load",function(e){i()}),window.addEventListener("shopify:block:select",function(i){if(d.length)for(var e=0;e<d.length;e++){var t=d[e].id;"shopify-section-"+i.detail.sectionId===t&&self["sliderItems"+t]&&setTimeout(function(e){i.detail.blockId.split("-");var t="qq"+e.replace("template--","").replace("shopify-section-","").replace("__",""),t=$("#"+t+' .qq-splitscreen-slide[data-shopify-editor-block=\'{"id":"'+i.detail.blockId+'","type":"slide"}\']:not(.slick-cloned)').attr("data-slick-index");$(d).find(".qq-splitscreen-slides");self["sliderItems"+e].slick("slickGoTo",Number(t),!0)},30,t)}})}();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
